<template>
    <div>
        <div class="carrusel-container">
            <div class="container-img">
                <Transition name="fade">
                    <img :src="props.images[currentImage].img" :alt="props.images[currentImage].alt" width="100%" height="100%"
                        class="carrusel-img" />
                </Transition>
            </div>
        </div>
        <div class="carrusel-group-btn">
            <button v-for="(image, index) in images" :key="index" @change="nextItemImage" @click="changeImage(index)"
                :class="{ active: index === activeIndex }" class="carrusel-btn">{{ index + 1 }}
            </button>
        </div>
    </div>

</template>
<script setup>
import { defineProps, ref, onMounted } from 'vue'
const props = defineProps({
    images: {
        type: Array,
    }
})
const activeIndex = ref(0)
const currentImage = ref(0)
const indexText = ref(0)
const changeImage = (index) => {
    activeIndex.value = index;
    currentImage.value = index;
}
const nextItemImage = () => {
    currentImage.value++
    activeIndex.value++
    if (props.images) {
        if (activeIndex.value >= props.images.length) {
            activeIndex.value = 0
        }
        if (currentImage.value == props.images.length) {
            currentImage.value = 0
        }
    }
}
const nextItemText = () => {
    indexText.value++
    if (props.text) {
        if (indexText.value >= props.text.length) {
            indexText.value = 0
        }
    }
}
onMounted(() => {
    setInterval(nextItemImage, 3000)
    setInterval(nextItemText, 3000)

})
</script>
<style>
.fade-enter-active,
fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
fade-leave-to {
    opacity: 0;
}

.carrusel-btn {
    border-radius: 50%;
    border: none;
    background-color: #007a5e;
    color: white;
    font-weight: bold;
    padding: 2px 6px;
    cursor: pointer;
}

.carrusel-btn.active {
    background-color: #89BB33;
}

.carrusel-group-btn {
    display: flex;
    justify-content: end;
    gap: 4px;
    z-index: 50;
    position: absolute;
    transform: translateY(-15px);
    right: 15px;
    padding: 0rem 1rem 0rem 0rem;
}

.carrusel-group-btn-text {
    display: flex;
    justify-content: end;
    align-items: center;
    gap: 4px;
    position: relative;
}

.carrusel-btn-text {
    border-radius: 50%;
    border: none;
    background-color: #CCCCCC;
    color: white;
    font-weight: bold;
    padding: 2px 6px;
    cursor: pointer;
}

.carrusel-btn-text.active {
    background-color: #AAAAAA;
}

.carrusel-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    overflow: clip;
    animation-duration: 2;
    animation-iteration-count: infinite;    
    position: relative;
    z-index: 1;   
}
.carrusel-container-text {
    display: flex;
    gap: 10px;
    font-family: Arial, sans-serif;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 0.3rem;
    padding: 1rem;
    position: relative;
    justify-items: center;
}

.carrusel-noticias {
    font-size: 14px;
    color: #888;
    box-sizing: border-box;
}

.carrusel-noticias a {
    color: #89BB33;
    font-weight: bold;
    text-decoration: underline;
}

.carrusel-container {
    box-sizing: border-box;
    position: relative;
}

.carrusel-noticias li {
    list-style-type: none;
}
</style>